module.exports = __webpack_public_path__ + "static/backup-1dbcb4b1582693f74a8de3908583e0bf.png";